import React from 'react';
import styled from 'styled-components/macro';

type Props = {
  progress: number;
};

const ProgressBarRoot = styled.div`
  background-color: #f5f5f5;
  bottom: 0;
  height: 6px;
  left: 0;
  position: absolute;
  right: 0;
  width: inherit;
`;

const CurrentProgress = styled.div<{ $progress: number }>`
  background-color: #ceab58;
  height: inherit;
  width: ${(props) => props.$progress}%;
`;

export const ProgressBar = (props: Props) => {
  const { progress = 0 } = props;

  if (!progress) {
    return null;
  }

  return (
    <ProgressBarRoot className="progress-bar">
      <CurrentProgress $progress={progress} />
    </ProgressBarRoot>
  );
};
